const SESSION_TIMEOUT = 60 * 60 * 1000

let inactivityTimer = null
let lastActivity = Date.now()

const resetTimer = () => {
  lastActivity = Date.now()
  if (inactivityTimer) {
    clearTimeout(inactivityTimer)
  }
  inactivityTimer = setTimeout(() => {
    checkSession()
  }, SESSION_TIMEOUT)
}

const checkSession = () => {
  const now = Date.now()
  if (now - lastActivity >= SESSION_TIMEOUT) {
    logout()
  }
}

export const initSession = () => {
  lastActivity = Date.now()
  resetTimer()

  const events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart', 'click']
  events.forEach(event => {
    document.addEventListener(event, resetTimer, { passive: true })
  })

  window.addEventListener('blur', checkSession)
}

export const destroySession = () => {
  if (inactivityTimer) {
    clearTimeout(inactivityTimer)
    inactivityTimer = null
  }
  const events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart', 'click']
  events.forEach(event => {
    document.removeEventListener(event, resetTimer)
  })
  window.removeEventListener('blur', checkSession)
}

export const login = (userData) => {
  sessionStorage.setItem('token', userData.token || 'session-token')
  sessionStorage.setItem('user', JSON.stringify(userData.user || {}))
  sessionStorage.setItem('accountSet', userData.accountSet || 'DEMO')
  sessionStorage.setItem('loginTime', Date.now().toString())
  initSession()
}

export const logout = () => {
  destroySession()
  sessionStorage.removeItem('token')
  sessionStorage.removeItem('user')
  sessionStorage.removeItem('accountSet')
  sessionStorage.removeItem('loginTime')
  window.location.href = '#/login'
  window.location.reload()
}

export const isLoggedIn = () => {
  return sessionStorage.getItem('token') !== null
}

export const getUser = () => {
  const userStr = sessionStorage.getItem('user')
  return userStr ? JSON.parse(userStr) : null
}

export const getAccountSet = () => {
  return sessionStorage.getItem('accountSet')
}

export const getRemainingTime = () => {
  const loginTime = parseInt(sessionStorage.getItem('loginTime') || '0')
  const elapsed = Date.now() - loginTime
  return Math.max(0, SESSION_TIMEOUT - elapsed)
}
